module.exports = __webpack_public_path__ + "static/media/Burkina.c4a204c5.png";